module.exports = __webpack_public_path__ + "img/2.5dbd8f03.jpg";